module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"thumbnails_title":"该商品的其他评论"}}')
  delete Component.options._Ctor
}
